import { DatePipe } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AuthService } from "@shared/auth/auth.service";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessExemptInspectionsViewModel } from "app/models/mainMenu/mainMenu";
import { IEnclosedAreaEditHistory } from "app/models/reports/reports";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";

@Component({
  selector: 'enclosedAreaEdit',
  styleUrls: ['./enclosedAreaEdit.component.scss'],
  templateUrl: './enclosedAreaEdit.component.html'
})

export class EnclosedAreaEditComponent implements OnInit {

  // currentInspection: IBusinessExemptInspectionsViewModel = {} as IBusinessExemptInspectionsViewModel;
  businessId: number = 0;
  saved: boolean = false;
  showSave: boolean = false;
  reviewed: boolean = false;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  isAdmin: boolean = false;

  enclosedArea: IEnclosedAreaEditHistory = {
    id: '0',
    businessId: 0,
    complaintId: 0,
    enclosedArea: false,
    enclosedAreaReviewed: false,
    enclosedAreaAdmin: false,
    enclosedAreaDetermination: '0',
    enclosedAreaDeterminationComments: '0',
    timeStamp: '0',
    loggedUser: '0',
    visitDate: '0',
    visitComments: '0',
    comments: '0',
    editHistory: [],
    files: []
  };


  // ids: boolean = false;

  form = new UntypedFormGroup({
    validEnclosedArea: new UntypedFormControl(''),
    determineDate: new UntypedFormControl(''),
    comments: new UntypedFormControl(''),
  });

  constructor(
    private sharedService: SharedService,
    private complaintService: ComplaintService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<EnclosedAreaEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    if (this.data.enclosedArea != null && this.data.enclosedArea != undefined) {
      this.enclosedArea = this.data.enclosedArea;
      this.form.controls['validEnclosedArea'].setValue(this.enclosedArea.enclosedAreaAdmin.toString());
      this.form.controls['determineDate'].setValue(new Date(this.enclosedArea.enclosedAreaDetermination));
      this.form.controls['comments'].setValue(this.enclosedArea.enclosedAreaDeterminationComments);
      this.showSave = true;
    }
    this.businessId = this.data.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
    this.isAdmin = this.authService.isAdmin;
  }

  save() {

    this.enclosedArea.enclosedAreaDeterminationComments = this.form.controls['comments'].value;
    // this.enclosedArea.enclosedAreaDetermination = this.form.controls['determineDate'].value;
    this.enclosedArea.enclosedAreaDetermination = this.datePipe.
       transform(this.form.controls['determineDate'].value, 'MM/dd/yyyy');
    this.enclosedArea.enclosedAreaAdmin = this.form.controls['validEnclosedArea'].value == 'true';
    this.complaintService.saveEnclosedArea(this.enclosedArea).subscribe({
      next: response => {
        this.sharedService.toastr.success("Saved");
        this.saved = true;
        this.return();
      },
      error: e => {
        this.sharedService.toastr.error("Could not save Area Info");
      },
    });

  }

  dateChanged(date: string) {
    this.enclosedArea.visitDate = date;
    this.showSave = date != null ? true : false;
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }
}